"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TransportationCustomLabelClient = void 0;
const base_client_1 = require("@deliverr/base-client");
const commons_logs_1 = require("@deliverr/commons-logs");
const ZPLCommandError_1 = require("./ZPLCommandError");
class TransportationCustomLabelClient extends base_client_1.ApiBasicAuthClient {
    constructor(config = {}, serviceUrl = process.env.TRANSPORTATION_SERVICE_URL, authUser = process.env.TRANSPORTATION_BASIC_AUTH_USER, authPasswd = process.env.TRANSPORTATION_BASIC_AUTH_PASSWORD) {
        super(Object.assign(Object.assign({}, config), { baseURL: `${config.baseURL || serviceUrl}/customLabel`, basicAuthPassword: authPasswd, basicAuthUser: authUser }));
        if (!serviceUrl) {
            commons_logs_1.log.warn("TRANSPORTATION_SERVICE_URL environment variable is not set");
        }
        if (!authUser || !authPasswd) {
            commons_logs_1.log.warn("TRANSPORTATION_BASIC_AUTH_USER and TRANSPORTATION_BASIC_AUTH_PASSWORD environment variable is not set");
        }
    }
    async addLabelFooter(addCustomLabelFooterRequest) {
        try {
            return await this.post("/v1/addLabelFooter", addCustomLabelFooterRequest);
        }
        catch (err) {
            throw (0, base_client_1.mapError)(err, [ZPLCommandError_1.ZPLCommandError.CANNOT_SHRINK_PARAMETER, ZPLCommandError_1.ZPLCommandError.UNKNOWN_ZPL_COMMAND]);
        }
    }
}
exports.TransportationCustomLabelClient = TransportationCustomLabelClient;
//# sourceMappingURL=TransportationCustomLabelClient.js.map